function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { scaleOrdinal } from 'd3-scale';
import { pie } from 'd3-shape';
import { rgb } from 'd3-color';
import Arc from './Arc';
import { getValidElementProps } from '../utils/htmlValidProps';

require('xps-style/core/donut.css');

var d3 = {
  scaleOrdinal: scaleOrdinal,
  pie: pie,
  rgb: rgb
};

var Donut = function Donut(props) {
  var data = props.data,
      colors = props.colors,
      className = props.className,
      onBlur = props.onBlur,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onKeyDown = props.onKeyDown,
      customLabel = props.customLabel,
      outerRadius = props.outerRadius;
  var colorScale;

  if (colors.length > 0) {
    var firstColor = colors[0];
    colorScale = firstColor.startsWith('rgb') || firstColor.startsWith('#') ? d3.scaleOrdinal().range(colors.map(function (value) {
      return d3.rgb(value);
    })) : d3.scaleOrdinal().range(colors.map(function (value) {
      return value;
    }));
  }

  var donut = d3.pie().value(function (d) {
    return d.value;
  }).sort(null).padAngle(0.01);
  var divProps = getValidElementProps('div', props);
  var classNames = cx({
    donutchart: true
  }, className);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classNames
  }, divProps), /*#__PURE__*/React.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 200 200",
    preserveAspectRatio: "xMinYMin meet",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(100,100)"
  }, donut(data).map(function (d, i) {
    return /*#__PURE__*/React.createElement(Arc, {
      onBlur: onBlur,
      onFocus: onFocus,
      onClick: onClick,
      onKeyDown: onKeyDown,
      d: d,
      color: colors.length > 0 ? colorScale(i) : '',
      key: d.index,
      outerRadius: outerRadius
    });
  }), customLabel ? customLabel() : null)));
};

Donut.propTypes = {
  /** array of color values */
  colors: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,

  /** function label for donut chart */
  customLabel: PropTypes.func,

  /** array of json data */
  data: PropTypes.array,

  /** is triggered on onMouseOut */
  onBlur: PropTypes.func,

  /** is triggered on onMouseOver */
  onFocus: PropTypes.func,

  /** is triggered when chart is clicked */
  onClick: PropTypes.func,

  /** is triggered when key is pressed */
  onKeyDown: PropTypes.func,

  /** distance of line from center of chart to edge */
  outerRadius: PropTypes.number
};
Donut.defaultProps = {
  colors: [],
  outerRadius: 25
};
Donut.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Donut",
  "props": {
    "colors": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "string"
        }
      },
      "required": false,
      "description": "array of color values"
    },
    "outerRadius": {
      "defaultValue": {
        "value": "25",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "distance of line from center of chart to edge"
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "customLabel": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "function label for donut chart"
    },
    "data": {
      "type": {
        "name": "array"
      },
      "required": false,
      "description": "array of json data"
    },
    "onBlur": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "is triggered on onMouseOut"
    },
    "onFocus": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "is triggered on onMouseOver"
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "is triggered when chart is clicked"
    },
    "onKeyDown": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "is triggered when key is pressed"
    }
  }
};
export default Donut;